import { Menu } from "@headlessui/react"

const baseUrl = () => (process.env.REACT_APP_INVENTORY_API_URL || "").replace(/\/$/, "")

const openExport = (poId, path) => {
  if (!poId) return
  window.open(`${baseUrl()}/purchase-orders/${poId}${path}`, "_blank")
}

const items = [
  {
    label: "Faktur PDF",
    description: "Format baru",
    path: "/print/faktur",
  },
  {
    label: "Surat Jalan PDF",
    description: "Format baru",
    path: "/print/delivery-order",
  },
  {
    label: "Faktur PRN",
    description: "Format lama",
    path: "/export-legacy/faktur",
  },
  {
    label: "Surat Jalan PRN",
    description: "Format lama",
    path: "/export-legacy/delivery-order",
  },
]

export default function PurchaseExportActions({ poId, align = "right", compact = false }) {
  if (!poId) return null

  return (
    <Menu as="div" className="relative inline-block text-left">
      <Menu.Button
        className={`inline-flex items-center gap-2 border border-neutral-200 bg-white text-neutral-800 shadow-sm transition hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-neutral-200 ${
          compact ? "px-3 py-2 text-[11px] rounded-lg" : "px-4 py-3 text-xs font-semibold rounded-xl"
        }`}
      >
        <span>Export</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-3.5 h-3.5 text-neutral-500"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="m6 9 6 6 6-6" />
        </svg>
      </Menu.Button>

      <Menu.Items
        className={`absolute z-30 mt-2 w-56 overflow-hidden rounded-xl border border-neutral-200 bg-white shadow-xl ring-1 ring-black/5 focus:outline-none ${
          align === "left" ? "left-0 origin-top-left" : "right-0 origin-top-right"
        }`}
      >
        <div className="px-3 py-2 text-[10px] font-semibold uppercase tracking-wide text-neutral-400 bg-neutral-50">
          Purchase Order
        </div>
        <div className="p-1">
          {items.map((item) => (
            <Menu.Item key={item.path}>
              {({ active }) => (
                <button
                  type="button"
                  onClick={() => openExport(poId, item.path)}
                  className={`flex w-full items-center justify-between rounded-lg px-3 py-2.5 text-left transition ${
                    active ? "bg-neutral-100" : "bg-white"
                  }`}
                >
                  <span className="text-xs font-semibold text-neutral-800">{item.label}</span>
                  <span className="text-[10px] text-neutral-500">{item.description}</span>
                </button>
              )}
            </Menu.Item>
          ))}
        </div>
      </Menu.Items>
    </Menu>
  )
}
